import { getQueryVariable, cache } from './index';

const COOKIE_CONFIG = { expires: 30 };
const UTM_COOKIES = ['utm_source', 'utm_medium', 'utm_campaign'];

function handleUtmCookie(key, value) {
  const cookieKey = `insta360.${key}`;
  if (value) {
    cache.setCookie(cookieKey, value, COOKIE_CONFIG);
  } else {
    cache.removeCookie(cookieKey);
  }
}

function Insrc() {
  this.code = cache.getCookie('insrc');
  const queryInsrc = getQueryVariable('utm_term') || getQueryVariable('insrc');
  const utmParams = UTM_COOKIES.reduce((acc, key) => {
    acc[key] = getQueryVariable(key);
    return acc;
  }, {});

  if (queryInsrc && /^[A-Za-z0-9\-_]+$/.test(queryInsrc)) {
    this.code = queryInsrc;
    this.source = utmParams.utm_source;
    this.medium = utmParams.utm_medium;
    this.campaign = utmParams.utm_campaign;

    cache.setCookie('insrc', queryInsrc, COOKIE_CONFIG);
    UTM_COOKIES.forEach((key) => handleUtmCookie(key, utmParams[key]));
  }
}

// 更新分销码并移除来源
export const updateInsrc = (insrc, source) => {
  cache.removeCookie('insrc');
  cache.setCookie('insrc', insrc, COOKIE_CONFIG);
  cache.setCookie('insta360.utm_source', source, COOKIE_CONFIG);
  ['insta360.utm_medium', 'insta360.utm_campaign'].forEach((key) => {
    cache.removeCookie(key);
  });
};

Insrc.prototype.getInsrc = function () {
  return this.code?.toUpperCase();
};

export default Insrc;
